import { Col, Row } from "antd";
import Image from "next/image";
import Link from "next/link";
import Typography from "../../../components/Typography";
import { Container, LinkContainer } from "./styled";

export default function ProductSubcategories({ subcategories }) {
  return (
    <Container>
      <Typography
        color="darkGray2"
        fontWeight="bold"
        fontSize="2rem"
        textAlign="center"
      >
        {subcategories.title}
      </Typography>
      <Row gutter={32}>
        {subcategories.items.map((subcategory) => (
          <Col xs={12} key={subcategory.id}>
            <Link href={subcategory.href}>
              <a>
                <LinkContainer>
                  <Image
                    alt="Subcategory"
                    {...subcategory.image}
                    layout="responsive"
                  />
                  <Typography
                    color="darkGray2"
                    fontWeight="bold"
                    fontSize="1.6rem"
                    textAlign="center"
                  >
                    {subcategory.text.toUpperCase()}
                  </Typography>
                </LinkContainer>
              </a>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
